import React from 'react';
import { TECHNOLOGIES } from '../../data/appData';

export default function TechnologiesSection() {
  return (
    <section className="section" style={{ background: 'var(--bg-primary)' }}>
      <div className="container">
        <div className="section-header">
          <div className="section-eyebrow">Teknolojilerimiz</div>
          <h2 className="section-title">
            Endüstrinin En İleri<br/>
            <span className="gradient-text">Ekipmanları</span>
          </h2>
          <p className="section-subtitle">
            Rakiplerimizin büyük çoğunluğunun kullanmadığı termal kamera, robotik ve akustik teknolojilerle çalışıyoruz.
          </p>
        </div>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
          gap: '20px',
        }}>
          {TECHNOLOGIES.map((tech, i) => (
            <div key={tech.name} style={{
              background: 'var(--bg-card)',
              borderRadius: 'var(--radius-xl)',
              border: '1px solid var(--border-color)',
              overflow: 'hidden',
              transition: 'all 0.3s',
            }}
            onMouseEnter={e => {
              e.currentTarget.style.transform = 'translateY(-8px) scale(1.01)';
              e.currentTarget.style.boxShadow = '0 24px 64px rgba(0,180,204,0.2), var(--shadow-lg)';
              e.currentTarget.style.borderColor = 'rgba(0,180,204,0.4)';
            }}
            onMouseLeave={e => {
              e.currentTarget.style.transform = 'translateY(0) scale(1)';
              e.currentTarget.style.boxShadow = 'none';
              e.currentTarget.style.borderColor = 'var(--border-color)';
            }}>
              {/* Header with gradient */}
              <div style={{
                background: 'var(--gradient-metal)',
                padding: '28px 24px',
                display: 'flex', alignItems: 'center', gap: '16px',
                position: 'relative', overflow: 'hidden',
              }}>
                <div style={{
                  position: 'absolute', right: '-20px', top: '-20px',
                  width: '100px', height: '100px',
                  borderRadius: '50%',
                  background: 'rgba(0,180,204,0.1)',
                }}/>
                <div style={{
                  width: '56px', height: '56px',
                  borderRadius: '14px',
                  background: 'rgba(0,180,204,0.15)',
                  border: '1px solid rgba(0,180,204,0.3)',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  fontSize: '26px',
                  flexShrink: 0,
                }}>{tech.icon}</div>
                <div>
                  <div style={{ fontFamily: 'var(--font-display)', fontWeight: 700, color: 'white', fontSize: '1.05rem' }}>{tech.name}</div>
                  <div style={{ fontFamily: 'var(--font-mono)', fontSize: '0.72rem', color: 'var(--teal)', letterSpacing: '0.05em' }}>{tech.brand}</div>
                </div>
              </div>

              <div style={{ padding: '20px 24px' }}>
                <p style={{ fontSize: '0.9rem', color: 'var(--text-muted)', lineHeight: 1.65, marginBottom: '16px' }}>
                  {tech.description}
                </p>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                  {tech.specs.map(spec => (
                    <div key={spec} style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '0.82rem', color: 'var(--text-secondary)' }}>
                      <span style={{ color: 'var(--teal)', flexShrink: 0 }}>▸</span>
                      {spec}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}
